import { getSubscriptionAccessLevel } from 'lib/utils';

const showPremiumModal = store => (shouldStay, accessLevel, flags) => {
  const state = store.getState();
  const currentSchool = state.currentUser ? state.currentUser.data.current_school : null;

  if (!currentSchool) {
    return;
  }

  const modals = state.modal.modals;
  const isPremiumModalOpen = modals.find(m => m.isVisible && m.component === 'Premium');
  const isSoftlockModalOpen = modals.find(m => m.isVisible && m.component === 'Softlock');

  if (isPremiumModalOpen || isSoftlockModalOpen) {
    return;
  }

  if (flags['subscription-softlock'] && !!currentSchool.softlocked_at) {
    Actions.showModal(
      'Softlock',
      {
        shouldStay,
        isAdmin: state.currentUser.data.teacher.is_admin
      },
      {
        className: 'modal--dark-top'
      }
    );
  } else {
    Actions.showModal(
      'Premium',
      {
        shouldStay,
        accessLevel: accessLevel || getSubscriptionAccessLevel(currentSchool)
      },
      {
        className: 'modal--dark-top'
      }
    );
  }
};

export default showPremiumModal;
